import React from 'react'
import SimulatorPage from './index'

const TrialPage = () => {
    return <SimulatorPage variant="trial" />
}

export default TrialPage
